import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-bd4264c6.js';
import './chunk-f647b5cb.js';
import './chunk-0928016a.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { S as Select } from './chunk-01bc3886.js';
export { S as BSelect } from './chunk-01bc3886.js';
var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Select);
  }
};
use(Plugin);
export default Plugin;